<template>
  <v-container class="pa-md-12">
    <v-empty-state>
      <template #media>
        <v-avatar color="warning" size="88" variant="tonal">
          <v-icon icon="fas fa-shield-exclamation" size="40" />
        </v-avatar>
      </template>
      <template #headline>
        <div class="text-headline-large">
          {{ t('error.403.box_elevated_auth_required.title') }}
        </div>
      </template>
      <template #title>
        <p class="mt-3">
          {{ t('error.403.box_elevated_auth_required.description') }}
        </p>
        <div class="mt-4">
          <DeepLink class="text-info text-body-small" :href="linkTwoFactorAuth">
            {{ t('error.403.box_elevated_auth_required.link_2fa_info') }}
          </DeepLink>
        </div>
      </template>
      <template #actions>
        <div class="d-flex flex-wrap justify-center ga-2 w-100">
          <VBtnTertiary :text="t('error.home')" :to="homeUrl" />
          <VBtnPrimary
            :href="twoFactorSetupUrl"
            :text="t('error.403.box_elevated_auth_required.btn_2fa')"
          />
        </div>
      </template>
    </v-empty-state>
  </v-container>
</template>

<script setup lang="ts">
import { DeepLink, getDeepAppUrlByEnv } from '@deepcloud/deep-ui-lib'
import { useKnowledgeCenter } from '@/composables/knowledge-center'

defineProps({
  homeUrl: {
    type: String,
    default: '/',
  },
})

const { t } = useI18n()
const { linkTwoFactorAuth } = useKnowledgeCenter()

const twoFactorSetupUrl = computed(
  () =>
    `${getDeepAppUrlByEnv('deepadmin', import.meta.env.VITE_ENVIRONMENT)}account/profile/security`,
)
</script>
